import { useContext, useMemo } from 'react';
import { AppConfigurationsContext } from '@investigator/shared/providers';

export interface IdentityIntegrationSettings {
  identityIntegrationEnabled: boolean;
}

export const useIdentityIntegrationSettings =
  (): IdentityIntegrationSettings => {
    const { appConfigurations } = useContext(AppConfigurationsContext);

    return useMemo(() => {
      const identityIntegrationEnabled =
        appConfigurations?.feature_flags?.identity_integration === true;
      return {
        identityIntegrationEnabled,
      };
    }, [appConfigurations]);
  };
